<osp-checkbox [formControl]="selectAllControl" (onChange)="$onSelectAll.emit($event.checked)" />
<osp-icon-field iconPosition="right" class="filter-field filter-field--search flex-grow-1">
  <osp-input-text #filterInputElem [formControl]="filterControl" (onInput)="filterChange$.next($event)" />
  <osp-input-icon>
    <i [ngClass]="['cursor-pointer', IconKey.UISelectErase | icon]" (click)="resetFilter()"></i>
    <i [ngClass]="IconKey.GlobalSearch | icon"></i>
  </osp-input-icon>
</osp-icon-field>
